:host {
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td {
        margin: 0;
        padding: 0;
        vertical-align: baseline;
        border: 0;
        font: inherit;
        font-size: 100%;
    }
    ti-opn-details {
        display: flex;
        flex-direction: column;
        min-width: 968px;
        padding: 10px;
        margin-bottom: 10px;
        height: auto;
        a {
            color: $pl-link-color-primary;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
        @media only screen and (max-width: 768px) {
            padding: 0;
            .ti-product-status {
                margin: 0 $polaris-space-2 $polaris-space-4 0;
            }
        }
    }

    // OPN Snapshot Styles
    .ti-opn-details {
        a {
            text-decoration: none;
            color: $polaris-color-teal5;

            &:hover {
                text-decoration: underline;
            }
        }

        &-part-info {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
        &-part-number {
            font-size: $polaris-font-size-3;
            font-weight: $polaris-font-weight-bold;
            line-height: $polaris-line-height-3;
            margin: 0 $polaris-space-2 0 0;
        }
        &-row {
            padding: $polaris-space-6 0;
            border-bottom: 1px solid $polaris-color-grey2;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            @media only screen and (max-width: 768px) {
                flex-direction: column;
                padding: $polaris-space-4 0 $polaris-space-2;
            }
        }
        &-info {
            margin-right: $polaris-space-4;
            @media only screen and (max-width: 768px) {
                margin-right: 0;
                padding-top: $polaris-space-1;
            }
        }
        &-alternate-parts {
            font-size: $polaris-font-size-1;
            margin-bottom: $polaris-space-4;
        }
        &-custom-reel-lot-date {
            margin-bottom: $polaris-space-1;
        }
        &-view-alternates {
            margin-top: $polaris-space-4;
            margin-bottom: $polaris-space-4;

            ti-titled-description + & {
                margin-top: 0;
            }

            .ti_p-iconText {
                display: flex;
                align-items: center;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }

                .ti_p-iconText-icon {
                    margin-right: $polaris-space-2;
                }
            }
        }
        &-info-list {
            padding: 0;
            margin: $polaris-space-2 0 0 0;
            list-style: none;
            li,
            &-item {
                padding: $polaris-space-1 0;
                margin: 0;
            }
            .ti-opn-details-info-list-qty {
                display: flex;
                align-items: baseline;
                flex-wrap: wrap;
                padding: 0;
                >span {
                    padding: $polaris-space-1 $polaris-space-1 $polaris-space-1 0;
                    white-space: nowrap;
                }
                ti-disclosure-list {
                    white-space: nowrap;
                    padding: $polaris-space-1 $polaris-space-1 $polaris-space-1 0;
                }
            }
        }
        &-tooltip-dialog-trigger {
            color: $pl-text-color-primary !important;
            font-family: $polaris-font-family;
            font-size: $polaris-font-size-1;
            line-height: $polaris-line-height-2;
            appearance: none;
            background: transparent;
            border: 0;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: $polaris-space-2;
            padding: 0;
        }
        &-add-to-cart {
            width: 250px;
            >*,
            ti-button {
                display: block;
            }
            ti-form-element {
                margin: 0!important;
            }
            .ti-opn-details-availability {
                align-items: flex-start;
                display: flex;
                margin-top: $polaris-space-2;

                & ti-svg-icon {
                    margin-right: $polaris-space-2;
                    position: relative;
                    top: -1px;
                }
            }
            .ti-added-to-cart-custom-reel {
                font-size: $polaris-font-size-2;
                margin-top: $polaris-space-3;
            }
            ti-add-to-cart {
                width: 100%;
            }
            @media only screen and (max-width: 768px) {
                width: 100%;
                margin-top: $polaris-space-4;
            }
        }
        &-out-of-stock-label {
            font-size: $polaris-font-size-2;
            font-weight: $polaris-font-weight-bold;
            margin-bottom: $polaris-space-2;
        }
        &-not-available-label {
            font-size: $polaris-font-size-2;
        }
        ti-disclosure-list {
            span[slot="label"] {
                line-height: $polaris-line-height-2;
            }
        }
    }
    ti-titled-description+.ti-opn-details-view-alternates {
        margin-top: $polaris-space-1;
    }
    .ti-opn-search-notify-me-link {
        display: flex;
        ti-svg-icon {
            margin-right: $polaris-space-1;
        }
    }
    .ti-opn-search-future-inventory {
        margin-top: $polaris-space-2;
    }
    h2.ti-add-to-cart-dialog-title {
        font-size: 28px;
        line-height: 36px;
        margin-bottom: 32px;
        font-weight: 300;
        color: #333;
    }
    ti-dialog {
        p {
            font-size: 14px;
            line-height: 20px;
            margin-top: 0px;
            margin-bottom: 24px;
            font-weight: 400;
        }
    }
}
